import { useContext, useMemo } from "react"
import { FeatureFlagContext } from "../../../../mp-core/FeatureFlagProvider"
import { getExcludedWidgetsByFeatureFlags } from "../helpers"

export const useReportingExcludedWidgets = () => {
  const { featureFlags, featureFlagsLoading } = useContext(FeatureFlagContext)

  const excludedWidgets = useMemo(() => {
    if (featureFlagsLoading) return []

    return getExcludedWidgetsByFeatureFlags(featureFlags || {})
  }, [featureFlags, featureFlagsLoading])

  return excludedWidgets
}
